<template>
  <div class="warning-wrap wrap">
    <div>
      <img src="@/assets/img/icon_warning.png" alt="" />
      <p class="warning-title">{{ $t('login.22') }}</p>
    </div>
    <ul>
      <p>{{ $t('login.23') }}</p>
      <li>{{ $t('login.18') }}</li>
      <li>{{ $t('login.34') }}</li>
    </ul>
    <!-- 提交 -->
    <gl-button class="login-btn" @click="handleLogin" type="primary">{{ $t('login.38') }}</gl-button>
  </div>
</template>

<script>
import GlButton from '@/components/gl-button'
export default {
  components: {
    GlButton
  },
  methods: {
    // 账号登录
    handleLogin() {
      // 注册企业埋点
      // this.$ga.event('FHRLogin', 'click', 'TeamCreation', 6)
      this.$router.push({
        path: '/register/team'
      })
    }
  }
}
</script>
